import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../../constants/componentTypes";
import * as config from "../../../../constants/config";
import * as settings from "../../../../constants/settings";
import * as statsTypes from "../../../../constants/statsTypes";
import * as matchingActions from "../../../../actions/matchingActions";
import * as statisticsTabActions from "../../../../actions/statisticsTabActions";
import * as navigationActions from "../../../../actions/navigationActions";
import * as formatHelper from "../../../../helpers/formatHelper";
import * as getterHelper from "../../../../helpers/getterHelper";
import * as modelHelper from "../../../../helpers/modelHelper";

import Modal from "../../../global/generic/Modal";
import Table, {TABLE_VARIANTS} from "../../../global/generic/Table";
import Button from "../../../global/generic/Button";

class CorrectionHistoryModal extends Component {
    ITEM_ONLY = translate("matching.itemOnly");
    ALL_CORRECTIONS = translate("matching.allCorrections");
    ALL_TILL_ITEMS = translate("matching.allTillItems");

    constructor(props) {
        super(props);

        this.state = {
            activeCorrection: props.statisticsId,
            selectedOption: this.ITEM_ONLY
        };
    }

    handleLoadFormula = () => {
        this.props.dispatchLoadFormulaDataFromStatisticsAction(this.props.tabId, this.state.activeCorrection);
        this.props.dispatchCloseModalAction();
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleSaveToCustomFormula = () => {
        let correction = getterHelper.getSimpleTreeObjectById(this.props.corrections, this.state.activeCorrection);

        if (correction !== null) {
            this.props.dispatchLoadFormulaMetaDataFromStatisticsAction(
                this.props.tabId,
                correction.id,
                matchingActions.saveHistoryFormulaAsCustom(this.props.tabId, correction)
            );
            this.props.dispatchCloseModalAction();
        }
    };

    handleSelectRow = (id) => {
        this.setState({activeCorrection: id});
    };

    handleChangeSelectedOption = (event) => {
        this.setState({selectedOption: event.target.value});
    };

    getNoDataTableRows = () => {
        return [
            modelHelper.buildTableRow([
                modelHelper.buildTableCell(translate("flashMessage.formulaDataUnavailable")),
                modelHelper.buildTableCell("")
            ])
        ];
    };

    getUnitName = () => {
        if (this.props.unit === settings.UNIT_SHOT) {
            return this.props.shotsName;
        }

        return this.props.unit;
    };

    getFormattedAmount = (amount) => {
        return formatHelper.formatDecimalNumber(amount) + " " + this.getUnitName();
    };

    getDispensedColorants = () => {
        let correction = getterHelper.getSimpleTreeObjectById(this.props.corrections, this.state.activeCorrection);

        if (correction === null) {
            return this.getNoDataTableRows();
        }

        switch (this.state.selectedOption) {
            case this.ITEM_ONLY:
                const colorants = correction.getColorantsByUnit(this.props.unit);

                if (colorants === null) {
                    return this.getNoDataTableRows();
                }

                return Object.keys(colorants)
                    .sort()
                    .map((colorant) => {
                        return modelHelper.buildTableRow([
                            modelHelper.buildTableCell(colorant),
                            modelHelper.buildTableCell(this.getFormattedAmount(colorants[colorant]))
                        ]);
                    });
            case this.ALL_CORRECTIONS:
                if (correction.parentId === null) {
                    return this.getNoDataTableRows();
                }

                const corrections = {};
                for (const [key, value] of Object.entries(correction.getColorantsByUnit(this.props.unit))) {
                    if (corrections[key] === undefined) {
                        corrections[key] = 0;
                    }

                    corrections[key] += value;
                }

                let parentId = correction.parentId;
                let parent = null;
                while (parentId !== null) {
                    parent = getterHelper.getSimpleTreeObjectById(this.props.corrections, parentId);

                    if (parent === null || parent.parentId === null) {
                        parentId = null;
                    } else {
                        parentId = parent.parentId;

                        for (const [key, value] of Object.entries(parent.getColorantsByUnit(this.props.unit))) {
                            if (corrections[key] === undefined) {
                                corrections[key] = 0;
                            }

                            corrections[key] += value;
                        }
                    }
                }

                if (Object.keys(corrections).length === 0) {
                    return this.getNoDataTableRows();
                }

                return Object.keys(corrections)
                    .sort()
                    .map((colorant) => {
                        return modelHelper.buildTableRow([
                            modelHelper.buildTableCell(colorant),
                            modelHelper.buildTableCell(this.getFormattedAmount(corrections[colorant]))
                        ]);
                    });
            case this.ALL_TILL_ITEMS:
                const cumulativeColorants = correction.getCumulativeColorantsByUnit(this.props.unit);

                if (cumulativeColorants === null) {
                    return this.getNoDataTableRows();
                }

                return Object.keys(cumulativeColorants)
                    .sort()
                    .map((colorant) => {
                        return modelHelper.buildTableRow([
                            modelHelper.buildTableCell(colorant),
                            modelHelper.buildTableCell(this.getFormattedAmount(cumulativeColorants[colorant]))
                        ]);
                    });
            default:
                return this.getNoDataTableRows();
        }
    };

    getDispensingLabel = (statRecord, level) => {
        if (level === 0) {
            return statRecord.colorName;
        }

        if (statRecord.colorsStatsTypeId === statsTypes.MODIFIED_AUTOMATIC_CORRECTION) {
            return translate("general.modifiedAutomaticCorrection") + " " + level;
        }

        return translate("general.correction") + " " + level;
    };

    getRecords = (corrections, level) => {
        let rows = [];

        for (let correction of corrections) {
            rows.push(
                modelHelper.buildTableRow(
                    [
                        modelHelper.buildTableCell(this.getDispensingLabel(correction.item, level)),
                        modelHelper.buildTableCell(formatHelper.formatDateTimeUtc(correction.item.timestampUtc))
                    ],
                    this.state.activeCorrection === correction.item.id ? "active" : "",
                    "item-" + correction.item.id,
                    {onClick: () => this.handleSelectRow(correction.item.id)},
                    this.getRecords(correction.nodes, level + 1)
                )
            );
        }

        return rows;
    };

    getContent = () => {
        if (this.props.corrections.length === 0) {
            return modelHelper.buildModalSection(
                <div className="col-12 flex flex-wrap "></div>,
                "flex-row-gap-10px flex-wrap slim-scroll col-12"
            );
        }

        return modelHelper.buildModalSection(
            <div className="col-12 flex flex-wrap ">
                <div className="col-12 bold padding-left-5 padding-bottom-10">
                    <div
                        className="color-square"
                        style={{
                            backgroundColor: this.props.color === null ? config.DEFAULT_RGB : this.props.color.rgb
                        }}
                    />
                    {this.props.color === null ? "-" : this.props.color.displayName},{" "}
                    <Translate value="general.fandeck" />:{" "}
                    {this.props.fandeck === null ? "-" : this.props.fandeck.displayName},{" "}
                    <Translate value="general.base" />: {this.props.base === null ? "-" : this.props.base.displayName}
                    , <Translate value="general.package" />:{" "}
                    {this.props.bipp === null ? "-" : this.props.bipp.displayName}
                </div>
                <div className="col-12 flex">
                    <div className="col-7 padding-5">
                        <Table
                            variant={TABLE_VARIANTS[0]}
                            className=" flex-child fill-flex-space slim-scroll"
                            allowToggleSubRows={false}
                            renderSubRows={true}
                            tableHeader={modelHelper.buildTableRow([
                                modelHelper.buildTableCell(translate("general.dispensing")),
                                modelHelper.buildTableCell(translate("general.date"))
                            ])}
                            tableRows={this.getRecords(this.props.corrections, 0)}
                            tableColumns={[
                                modelHelper.buildTableColumn("col-6 vertical-center"),
                                modelHelper.buildTableColumn("col-3 vertical-center")
                            ]}
                        />{" "}
                    </div>
                    <div className="col-5 padding-10">
                        <div className="col-12 flex flex-align-center-vertical padding-bottom-10">
                            <Translate className="padding-right-10" value="general.colorants" />
                            <select
                                className="input-dark name-select primary-select"
                                style={{width: "-webkit-fill-available"}}
                                value={this.state.selectedOption}
                                onChange={this.handleChangeSelectedOption}
                            >
                                <option>{this.ITEM_ONLY}</option>
                                <option>{this.ALL_CORRECTIONS}</option>
                                <option>{this.ALL_TILL_ITEMS}</option>
                            </select>{" "}
                        </div>
                        <Table
                            variant={TABLE_VARIANTS[0]}
                            className="flex-child fill-flex-space"
                            tableRows={this.getDispensedColorants()}
                            tableColumns={[
                                modelHelper.buildTableColumn("col-6 vertical-center"),
                                modelHelper.buildTableColumn("col-3 vertical-center")
                            ]}
                        />
                    </div>
                </div>
            </div>,
            "flex-row-gap-10px flex-wrap slim-scroll col-12"
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <Button
                    label={<Translate value="matching.saveAsCustomFormula" />}
                    onClick={this.handleSaveToCustomFormula}
                />
                <Button label={<Translate value="general.loadFormula" />} onClick={this.handleLoadFormula} />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="matching.correctionHistory" />)}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{width: "60%", maxHeight: "60%"}}
            />
        );
    }
}

const mapStoreToProps = (store, ownProps) => {
    if (store.formula[ownProps.tabId] === undefined || store.statisticsTab.correctionHistory === null) {
        return {
            corrections: [],
            statisticsId: null,
            fandeck: null,
            color: null,
            base: null,
            bipp: null,
            unit: store.settings.formulaUnits,
            shotsName: store.settings.shotsName
        };
    }

    return {
        corrections: store.statisticsTab.correctionHistory,
        statisticsId: store.formula[ownProps.tabId].statisticsId,
        fandeck: store.formula[ownProps.tabId].fandeck,
        color: store.formula[ownProps.tabId].color,
        base: store.formula[ownProps.tabId].base,
        bipp: store.formula[ownProps.tabId].bipp,
        unit: store.settings.formulaUnits,
        shotsName: store.settings.shotsName
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.CORRECTION_HISTORY_MODAL));
        },
        dispatchLoadFormulaDataFromStatisticsAction: (tabId, statId) => {
            dispatch(statisticsTabActions.loadFormulaDataFromStatistics(tabId, statId));
        },
        dispatchLoadFormulaMetaDataFromStatisticsAction: (tabId, statId, next) => {
            dispatch(statisticsTabActions.loadFormulaMetaDataFromStatistics(tabId, statId, next));
        }
    };
};

export default CorrectionHistoryModal = connect(mapStoreToProps, mapDispatchToProps)(CorrectionHistoryModal);
